export const WEB_SOCKET_RECEIVED = 'WEB_SOCKET_RECEIVED';
